import { lazy, Suspense, useMemo } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { FeedbackState, PageContent, PageHeader, PageShell } from "@h2j-data-team/ui";

import { getChangelogEntries } from "@/lib/changelog";
import { PRODUCT_NAME } from "@repo/shared";

// The Markdown renderer weighs more than the rest of the page: it loads on demand.
const ChangelogEntries = lazy(() => import("@/components/changelog-entries"));

export const Route = createFileRoute("/_authenticated/changelog")({
  staticData: { pageTitle: "breadcrumbs.changelog" },
  component: ChangelogPage,
});

function ChangelogPage() {
  const { t, i18n } = useTranslation("changelog");
  const locale = i18n.language;

  const entries = useMemo(() => getChangelogEntries(locale), [locale]);

  return (
    <PageShell
      header={
        <PageHeader
          title={t("title")}
          description={t("description", { productName: PRODUCT_NAME })}
        />
      }
    >
      <PageContent>
        <div className="max-w-[760px]">
          {entries.length === 0 ? (
            <FeedbackState state="empty" title={t("empty")} />
          ) : (
            <Suspense fallback={<FeedbackState state="loading" title={t("loading")} />}>
              <ChangelogEntries entries={entries} />
            </Suspense>
          )}
        </div>
      </PageContent>
    </PageShell>
  );
}
